import { render, staticRenderFns } from "./refuse-dialog.vue?vue&type=template&id=1084bad3&scoped=true&"
import script from "./refuse-dialog.vue?vue&type=script&lang=js&"
export * from "./refuse-dialog.vue?vue&type=script&lang=js&"
import style0 from "./refuse-dialog.vue?vue&type=style&index=0&id=1084bad3&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1084bad3",
  null
  
)

export default component.exports